// extracted by css-extract-rspack-plugin
export default {"controls":"HHKWM","track":"iQlVe","pointer":"NCd_M","saturationPointer":"reD2T","huePointer":"Q3dzW"};